// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title {\n  font-style: normal;\n  font-weight: 700;\n  font-size: 18px;\n  color: #373737;\n}\n.trail {\n  font-weight: 400;\n  font-size: 18px;\n  color: #373737;\n}\n.next,\n.prev {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
